import { RouteType } from "types/RouteType";
import type { RootStore } from "stores/index";
import FiscalPeriodsStore from "./FiscalPeriods.Store";

/**
 * FiscalPeriods Route
 *
 * Manage fiscal periods per Phase 5
 * - View period status by company
 * - Close/reopen periods (restricted)
 * - CPA adjustments
 */
const fiscalPeriodsRoute: RouteType = {
  name: "Fiscal Periods",
  path: "/accounting/fiscal-periods",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Fiscal Periods",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./FiscalPeriods.Header"),
    },
    body: {
      component: () => import("./FiscalPeriods.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).fiscalPeriodsStore as FiscalPeriodsStore;
    if (store) {
      await store.loadFiscalPeriods();
    }
    return true;
  },
  dialogs: [
    {
      name: "closeFiscalPeriod",
      title: "Close Fiscal Period",
      component: () => import("./dialogs/ClosePeriodDialog.Body"),
      cancelButton: true,
      height: 400,
    },
    {
      name: "reopenFiscalPeriod",
      title: "Reopen Fiscal Period",
      component: () => import("./dialogs/ReopenPeriodDialog.Body"),
      cancelButton: true,
      height: 350,
    },
    {
      name: "cpaAdjustment",
      title: "CPA Adjustment",
      component: () => import("./dialogs/CPAAdjustmentDialog.Body"),
      cancelButton: true,
      height: 500,
    },
  ],
};

export default fiscalPeriodsRoute;
